<!-- 成果确认 -->
<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="page-title text-center">服务成果确认</div>
            <div class="page-caption">
                <div class="cell">
                    <div class="cell__label">项目名称：</div>
                    <div class="cell__value">{{info.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">服务人员：</div>
                    <div class="cell__value">{{info.member.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">预计完成时间：</div>
                    <div class="cell__value">{{info.complete_time}}</div>
                </div>
            </div>
            <div class="page-content">
                <div class="caption">
                    <div class="cell">服务内容</div>
                    <div class="cell">单位</div>
                    <div class="cell">服务要求</div>
                    <div class="cell">需求数量</div>
                    <div class="cell">确认数量</div>
                    <div class="cell">奖励金额</div>
                    <div class="cell">服务单价</div>
                </div>
                <div class="box" v-for="(item, index) in service" :key="index">
                    <div class="cell">
                        <el-tooltip :content="item.name">
                            <div class="content-ellipsis">{{item.name}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.unit}}</div>
                    <div class="cell">
                        <el-tooltip :content="item.demand">
                            <div class="content-ellipsis">{{item.demand}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.amount}}</div>
                    <div class="cell">
                        <el-input v-model="service[index].count"></el-input>
                    </div>
                    <div class="cell">
                        <el-input v-model="service[index].award"></el-input>
                    </div>
                    <div class="cell">
                        <el-input v-model="service[index].price"></el-input>
                    </div>
                </div>
            </div>
            <div class="page-footer">
                <div class="handler-wraper">
                    <el-button type="default" style="margin-right: 20px;"
                               @click="goPage(`/index/project/detail?id=${$route.query.id}&panel=1`)">返回
                    </el-button>
                    <el-button type="primary" @click="toNextStep">下一步</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router'
import qs from 'qs'

export default {
    name: 'Detail',
    inject: ['goPage'],
    data () {
        return {
            service: [],
            info: {
                member: {}
            }
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
    },
    methods: {
        getInfo (id, sub_id) {
            this.$http.get('/api/user/project/subinfo', {
                params: {
                    id,
                    sub_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.info = res.data
                        let arr = res.data.service.listData
                        this.service = arr.map(item => {
                            return {
                                amount: item.amount,
                                demand: item.demand,
                                id: item.id,
                                money: item.money,
                                name: item.name,
                                price: '',
                                count: '',
                                award: undefined,
                                unit: item.unit
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        toNextStep () {
            let err = 0
            for (let i = 0; i < this.service.length; i++) {
                let item = this.service[i]
                if (item.count !== '' && !/^[1-9]\d*$/.test(item.count)) {
                    this.$message.error({
                        message: '请填写正确的确认数量',
                        center: true
                    })
                    err++
                    return false
                } else if (item.count >= 10000) {
                    this.$message.error({
                        message: '数量不能多于10000',
                        center: true
                    })
                    err++
                    return false
                } else if (typeof item.award !== 'undefined' && item.award !== '' && !/(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/.test(item.award)) {
                    this.$message.error({
                        message: '请填写正确的奖励金额',
                        center: true
                    })
                    err++
                    return false
                } else if (item.award * 1 > 100000) {
                    this.$message.error({
                        message: '奖励金额不能超过100000',
                        center: true
                    })
                    err++
                    return false
                } else if (item.price !== '' && !/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(item.price)) {
                    this.$message.error({
                        message: '请填写正确的服务单价',
                        center: true
                    })
                    err++
                    return false
                }
                if (item.count !== '' && item.count * 1 !== 0) {
                    if (item.price === '' || item.price * 1 === 0) {
                        this.$message.error({
                            message: '请填写服务单价',
                            center: true
                        })
                        err++
                        return false
                    }
                }
                if (item.price !== '' && item.price * 1 !== 0) {
                    if (item.count === '' || item.count * 1 === 0) {
                        this.$message.error({
                            message: '请填写正确的确认数量',
                            center: true
                        })
                        err++
                        return false
                    }
                }
            }
            let totalCount = 0
            this.service.forEach(item => {
                if (item.count !== '') {
                    totalCount += Number(item.count)
                }
                if (item.award === '' || typeof item.award === 'undefined') {
                    let a = 0
                    item.award = a.toFixed(2)
                } else {
                    item.award = (item.award * 1).toFixed(2)
                }
                item.price = (item.price * 1).toFixed(2)
            })

            if (totalCount === 0) {
                this.$message.error({
                    message: '请至少填写一项成果',
                    center: true
                })
                return false
            }
            if (err !== 0) {
                return false
            }
            this.service.forEach(item => {
                if (item.count === '') {
                    item.count = 0
                }
            })
            const payloadService = this.service.map(s => ({
                id: s.id,
                award: s.award,
                price: s.price,
                amount: Number(s.count || 0)
            }))

            const postData = {
                id: this.$route.query.id,
                sub_id: this.$route.query.sub_id,
                service: JSON.stringify(payloadService)
            }

            this.$http.post('/api/user/project/subbeforeconfirmresults', qs.stringify(postData))
                .then((res) => {
                    if (res.code === 0) {
                        let QRESULT = {
                            id: this.$route.query.id,
                            sub_id: this.$route.query.sub_id,
                            name: this.info.name,
                            member: this.info.member.name,
                            complete_time: this.info.complete_time,
                            service: this.service,
                            preview: res.data
                        }
                        window.localStorage.setItem('QRESULT', JSON.stringify(QRESULT))
                        router.push('/index/project/getresult')
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$message.error('网络错误，请稍候再试')
                })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var.scss";
@import "../../assets/style/sub.scss";

.page-title {
    padding-top: 43px;
    font-size: 20px;
    font-weight: bold;
}

.page-caption {
    display: flex;
    margin-top: 25px;
    margin-bottom: 15px;
    padding: 0 20px;

    .cell {
        flex: 1;
        display: flex;

        &:nth-child(2) {
            justify-content: center;
        }

        &:last-child {
            justify-content: flex-end;
        }
    }
}

.page-content {
    padding: 0 20px;

    .caption {
        display: flex;
        background-color: #F5F5FA;
        color: #909399;
        border-bottom: 1px solid $--border-color-base;
        border-top: 1px solid $--border-color-base;
    }

    .box {
        display: flex;
        border-bottom: 1px solid $--border-color-base;
    }

    .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 48px;
        padding-left: 10px;
        display: flex;
        align-items: center;

        &:nth-child(1) {
            width: 150px;
        }

        &:nth-child(2) {
            width: 100px;
        }

        &:nth-child(3) {
            flex: 1;
        }

        &:nth-child(4) {
            width: 100px;
        }

        &:nth-child(5) {
            width: 120px;
        }

        &:nth-child(6) {
            width: 120px;
        }

        &:nth-child(7) {
            width: 120px;
        }
    }
}

.page-footer {
    padding-bottom: 50px;

    .handler-wraper {
        width: 322px;
        margin: 138px auto 0;

        button {
            width: 144px;
        }
    }
}
</style>
